<template>
  <div class="checkout">
    <div class="container">
      <div class="row pb-4">
        <div class="col-md-12">
          <LoadedComponent :loading="loading" :percentual="percentual" />
        </div>

        <div class="col-lg-12" v-if="!loading">
          <AlertComponent :message="successMessage" :alert-type="'success'" />
          <AlertComponent :message="error" :alert-type="'danger'" />
          <h2 class="checkout-title" style="font-size: 4rem">
            Aggiornamento articolo
          </h2>
          <!-- End .checkout-title -->

          <ul class="nav nav-tabs nav-tabs-bg bg-light" id="tabs-1" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="tab-1-tab" data-toggle="tab" href="#tab-1" role="tab" aria-controls="tab-1"
                aria-selected="true">Dati dell'articolo</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" id="tab-2-tab" data-toggle="tab" href="#tab-2" role="tab" aria-controls="tab-2"
                aria-selected="true">Allegati caricati</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" id="tab-2-tab" data-toggle="tab" href="#tab-3" role="tab" aria-controls="tab-2"
                aria-selected="true">Carica allegati</a>
            </li>
          </ul>
          <div class="tab-content tab-content-border bg-light" id="tab-content-1">
            <div class="tab-pane fade show active bg-light" id="tab-1" role="tabpanel" aria-labelledby="tab-1-tab">
              <form class="pt-4 pr-4 pl-4" @submit.prevent="update_article">
                <div class="row">
                  <div class="col-sm-12">
                    <label for="nome_articolo">Titolo *</label>
                    <input type="text" class="form-control" name="nome" id="nome_articolo"
                      placeholder="Scrivi il titolo dell' articolo" v-model="form.name" />
                    <div class="alert alert-danger" v-if="errors.name">
                      {{ errors.name[0] }}
                    </div>
                  </div>

                  <div class="col-md-12">
                    <label for="distretto_anatomico" class="form-label">Distretto Anatomico</label>
                    <select class="form-control" v-model="form.anatomical_district_id" id="distretto_anatomico"
                      name="id_distretto">
                      <option value="0" selected disabled>
                        Seleziona il distretto anatomico
                      </option>
                      <option v-for="anatomical in anatomicalDistrict" :key="anatomical.id" :value="anatomical.id">
                        {{ anatomical.name }}
                      </option>
                    </select>
                    <div class="alert alert-danger" v-if="errors.anatomical_district_id">
                      {{ errors.anatomical_district_id[0] }}
                    </div>
                  </div>

                  <div class="col-sm-12">
                    <h5 class="card-title text-center mb-1">Trattamenti</h5>
                    <p class="mb-2 text-center">Seleziona i trattamenti</p>
                    <div class="row">
                      <div v-for="patology in patologies" :key="patology.id" class="col-md-2">
                        <!-- Categoria con icona per aprire/chiudere -->
                        <div class="mb-1">
                          <input type="checkbox" v-model="form.patologies" :value="patology.id" />
                          {{ patology.name }}
                        </div>

                        <!-- Sottocategorie sovrapposte -->
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <label for="descrizione">Descrizione </label>
                    <textarea class="form-control" id="descrizione" rows="3" v-model="form.description"
                      name="descrizione" placeholder="Descrizione dell'articolo"></textarea>

                    <div class="alert alert-danger" v-if="errors.description">
                      {{ errors.description[0] }}
                    </div>
                  </div>
                </div>
                <!-- End .col-sm-6 -->
                <div class="row flex-column pb-2 pl-2 pr-2">
                  <div class="flex-row">
                    <button type="submit" class="btn btn-primary float-right">
                      Aggiorna l'articolo<i class="las la-save"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div class="tab-pane fade show" id="tab-2" role="tabpanel" aria-labelledby="tab-2-tab">
              <div class="row">
                <div class="entry-container col-md-4" data-layout="fitRows" v-for="allegato in attachments"
                  :key="allegato.id">
                  <div class="p-4">
                    <article class="entry entry-grid text-center">
                      <figure class="entry-media">
                        <div>
                          <div v-if="allegato.type_file == 'mp4'">
                            <video-component :options="getOptons(allegato.path)"></video-component>
                          </div>
                          <div v-else-if="
                            allegato.type_file == 'jpg' ||
                            allegato.type_file == 'jpeg' ||
                            allegato.type_file == 'png'
                          ">
                            <img :src="allegato.path" alt="" />
                          </div>
                          <div v-else>
                            <iframe class="embed-responsive-item" :src="allegato.path" allowfullscreen>Contenuto
                            </iframe>
                          </div>
                        </div>
                      </figure>
                      <button type="button" class="btn btn-link" @click="deleteAttachment(allegato.id)">
                        Elimina
                      </button>

                      <!-- End .entry-cats </div>-->

                      <!-- End .entry-body -->
                    </article>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade show" id="tab-3" role="tabpanel" aria-labelledby="tab-3-tab">
              <div class="row pt-4 pr-4 pl-4">
                <div class="col-md-12">
                  <h2 class="checkout-title" style="font-size: 2rem">
                    Carica allegati <br /><small>Seleziona i tuoi file e confermali facendo click su
                      "Invia file"</small>
                  </h2>
                  <!-- End .checkout-title -->
                  <form @submit.prevent="upload_attachments">
                    <div class="input-group mb-3">
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" name="files[]" ref="fileInput"
                          @change="handleFileUpload" id="fileInput" aria-describedby="inputGroupFileAddon01" multiple />
                      </div>
                      <label class="custom-file-label text-center labels-files" for="fileInput" id="labelsfiles">{{
                        nameFiles }}
                      </label>
                    </div>

                    <!--d-none -->
                    <a href="#tab-1" id="cover-neurohub" class="btn btn-link d-none" role="tab" aria-controls="tab-1"
                      aria-selected="true" data-toggle="tooltip" data-placement="left"
                      title="Puoi ricontrallare i dati del tuo caso e scegliere una copertina fra le immagini che hai appena caricato">Fra
                      le immagini che hai appena caricato vuoi dare una
                      copertina al caso clinico? Se si clicca qui.</a>
                    <div class="row flex-column pb-2 pl-2 pr-2">
                      <div class="flex-row">
                        <button type="submit" class="btn btn-primary float-right">
                          Salva i nuovi file <i class="las la-save"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VideoComponent from "@/components/VideoComponent.vue";
import httpauth from "@/services/httpauth.js";
import httpservices from "@/services/httpservices.js";
import { useAuth } from "@/stores/auth.js";
import AlertComponent from "@/components/AlertComponent.vue";
import LoadedComponent from "@/components/LoadedComponent.vue";
//import router from "@/router";
export default {
  name: "LibraryEdit",
  components: { AlertComponent, LoadedComponent, VideoComponent }, //
  props: ["slug"],
  data() {
    return {
      library: [],
      permission: {},
      patologies: [],
      categoryMedical: [],
      successMessage: "",
      errors: [],
      anatomicalDistrict: [],
      request: {
        model: "activity",
        model_id: 0,
      },
      nameFiles: "Scegli i file (MAX 1 GIGA)",
      selectedFiles: "",
      attachments: [],
      percentual: "",
      loading: true,
      form: {
        id: 0,
        name: "",
        patologies: [],
        subpatologies: [],
        anatomical_district_id: 0,
        description: "",
      },
    };
  },
  mounted() {
    this.fetchPatology();
    this.fetchAtomicalDistrict();
    this.loadLibrary();
    this.loadPermission();
  },
  created() { },
  methods: {
    getOptons(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    async loadLibrary() {
      httpauth
        .get("/libraries/" + this.slug)
        .then((response) => {
          this.library = response.data.data;
          this.attachments = this.library.attachments;
          this.form.id = this.library.id;
          this.form.name = this.library.name;
          this.form.anatomical_district_id =
            this.library.anatomical_district_id;
          this.form.description = this.library.description;
          this.form.patologies = this.library.patologies;
          this.form.patologies = this.library.patologies.map(
            (subpatology) => subpatology.id
          );

          this.loading = false;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },

    async update_article() {
      this.loading = true;
      await httpauth
        .put("/libraries/" + this.form.id, this.form)
        .then((response) => {
          this.successMessage = response.data.message;
          this.loading = false;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
    async loadAttachment(model_id) {
      this.request.model_id = model_id;
      this.loading = true;
      await httpauth
        .post("/attachments/show", this.request)
        .then((response) => {
          var data = response.data.data;
          this.attachments = data;

          this.loading = false;

          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = Array.from(event.target.files);
      const totalSize = files.reduce(
        (accumulator, file) => accumulator + file.size,
        0
      );
      const validFiles = [];
      if (totalSize <= maxSize)
      {
        const allowedTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.ms-office",
          "video/mp4",
          "image/jpeg",
          "image/png",
          "image/jpg",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        Array.from(files).forEach((file) => {
          // Esegui l'azione desiderata su ogni file
          if (
            !allowedTypes.includes(file.type) ||
            !httpservices.checkDicom(file)
          )
          {
            alert(
              "Per favore seleziona un file valido (PDF/DOC/DOCX/JPEG/JPG/PNG/MP4/DCM)."
            );
            this;
            return;
          }
          validFiles.push(file.name);
        });

        this.selectedFiles = files;
        this.nameFiles = validFiles.join(", ");
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
    async upload_attachments() {
      this.loading = true;
      await httpservices
        .uploadAttachments(
          this.selectedFiles,
          this.library.id,
          "activity",
          0,
          (percentCompleted) => {
            this.percentual = percentCompleted;
            // Puoi fare qualcosa con il valore percentCompleted qui
          }
        )
        .then((response) => {
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";
          this.loading = false;
          this.success = response.data.message;
          if (response.data.status)
          {
            this.attachments = this.loadAttachment(this.library.id);
          }

          return;
        })
        .catch(() => {
          this.loading = false;
          this.error = "Gli allegati non sono stati caricati";
        });
    },
    async deleteAttachment(attachmentId, index) {
      httpservices
        .deleteAttachment(attachmentId)
        .then((response) => {
          this.success = response.data.message;
          this.attachments.splice(index, 1);
        })
        .catch((error) => {
          if (error.response.message)
          {
            this.error = error.response.message;
          }
        });
    },
    async loadPermission() {
      await httpservices
        .checkPermission(1, "biblioteca", "create_biblioteca")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async fetchCategoryMedical() {
      await httpservices
        .getCategoryMedical()
        .then((response) => {
          this.categoryMedical = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchPatology() {
      await httpservices
        .getPatology()
        .then((response) => {
          this.patologies = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async fetchAtomicalDistrict() {
      await httpservices
        .getAnatomicalDistrict()
        .then((response) => {
          this.anatomicalDistrict = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>